import React, { FC } from "react";
import { ItemDisplay } from "@narvar/nth-hook-loma";
import { getItemAttrs, getItemProps } from "./utils/itemSelectorHelper";
import { ItemCard } from "./components";
import { Maybe, useLanguage } from "@narvar/nth-kit-returns-headless";
import { ExtendedOrderItem } from "../ReturnReasons/types";

interface Props {
  shopNowItems: ExtendedOrderItem[];
  itemDisplay?: Maybe<ItemDisplay>;
  locale?: string;
  includeCurrency?: boolean;
}

export const ShopNowItems: FC<Props> = ({
  itemDisplay,
  shopNowItems,
  locale,
  includeCurrency,
}) => {
  const { rawValue: skuLabel } = useLanguage({
    langKey: "returnsItemListItemInfoskuLabel",
  });
  const { rawValue: qtyLabel } = useLanguage({
    langKey: "returnsItemListItemInfoqtyLabel",
  });
  const { rawValue: colorLabel } = useLanguage({
    langKey: "returnsItemListItemInfocolorLabel",
  });
  const { rawValue: sizeLabel } = useLanguage({
    langKey: "returnsItemListItemInfosizeLabel",
  });

  return (
    <>
      {shopNowItems.map((item) => {
        return (
          <ItemCard
            key={`${item.sku ?? ""}${item.itemId ?? ""}`}
            {...getItemProps({ item })}
            attributes={getItemAttrs({
              locale,
              includeCurrency,
              item,
              itemDisplay,
              selectedQuantity: item?.quantity,
              labels: {
                skuLabel,
                qtyLabel,
                colorLabel,
                sizeLabel,
              },
            })}
            hasShippingProtection={item.hasShippingProtection}
          />
        );
      })}
    </>
  );
};
